import React from 'react'

const Idd = React.lazy(() => import("./views/util-page/IDD"))
const Activate = React.lazy(() => import("./views/Activate"))
const Bo50GB = React.lazy(() => import("./views/business-plan/BoPlan50"))
const FiveGBundle = React.lazy(() => import("./views/FiveGBundle"))
const PressRelease = React.lazy(() => import('./views/util-page/PressRelease'))
const Careers = React.lazy(() => import("./views/util-page/Careers"))
const CareerTerms = React.lazy(() => import("./views/util-page/CareerTerms"))
const Cis = React.lazy(() => import("./views/util-page/CIS"))
const UserGuide = React.lazy(() => import("./views/util-page/UserGuide"))
const Complaint = React.lazy(() => import("./views/util-page/Complaint"))
const CisNEWIDD = React.lazy(() => import("./views/util-page/CISNEWIDD"))
const Roaming = React.lazy(() => import("./views/util-page/RoamingPH2"))
const DataProtection = React.lazy(() => import("./views/util-page/DataProtection"))
const Collect = React.lazy(() => import("./views/util-page/Collect"))
const Walkin = React.lazy(() => import("./views/util-page/Walkin"))
const Terms = React.lazy(() => import("./views/util-page/Terms"))
const SeniorsSignUpNew = React.lazy(() => import("./views/personal-plan/sim-senior/SignUpNew"))
const LuckyNumber = React.lazy(() => import("./views/util-page/LuckyNumber"))
const Account = React.lazy(() => import("./views/Account"))
const WirelessSg = React.lazy(() => import("./views/util-page/WirelessSg"))
const Prohibited = React.lazy(() => import("./views/util-page/Prohibited"))
const ProhibitedMt1 = React.lazy(() => import("./views/util-page/prohibited/Mt1"))
const ProhibitedMt2 = React.lazy(() => import("./views/util-page/prohibited/Mt2"))
const ProhibitedMt3 = React.lazy(() => import("./views/util-page/prohibited/Mt3"))
const ProhibitedMt4 = React.lazy(() => import("./views/util-page/prohibited/Mt4"))
const ProhibitedMt5 = React.lazy(() => import("./views/util-page/prohibited/Mt5"))
const ProhibitedMt6 = React.lazy(() => import("./views/util-page/prohibited/Mt6"))
const ProhibitedMt7 = React.lazy(() => import("./views/util-page/prohibited/Mt7"))
const ProhibitedMt8 = React.lazy(() => import("./views/util-page/prohibited/Mt8"))
const ProhibitedMt9 = React.lazy(() => import("./views/util-page/prohibited/Mt9"))
const SuperIddPack = React.lazy(() => import("./views/personal-plan/SuperIddPack"))
const Forms = React.lazy(() => import("./views/util-page/Forms"))
const Esim = React.lazy(() => import('./views/util-page/ESim'))
const GiveawayCampaign = React.lazy(() => import('./views/util-page/GiveawayCampaign'))
const Wifi = React.lazy(() => import('./views/util-page/Wifi'))
const HelpRedirect = React.lazy(() => import("./views/util-page/Help"))
const GetIdentify = React.lazy(() => import("./views/util-page/GetIdentify"))
const ZteCampaign = React.lazy(() => import("./views/campaign/ZteCampaign"))
const RechargeCampaign = React.lazy(() => import("./views/campaign/RechargeAndWin"))
const Getsimba5gCampaign = React.lazy(() => import("./views/campaign/Getsimba5gCampaign"))
const BroadbandSetup = React.lazy(() => import("./views/util-page/fbb/BroadbandSetup"))
const SingpassSuccess = React.lazy(() => import("./views/singpass/success"))
const SingpassError = React.lazy(() => import("./views/singpass/error"))
const ONTCollect = React.lazy(() => import("./views/util-page/ONTCollect"))

// New Design
const HomePH2 = React.lazy(() => import("./views/HomePH2"))
const NewDOPlan = React.lazy(() => import("./views/personal-plan/NewDOPlan"))
const Bo15 = React.lazy(() => import("./views/business-plan/BOPlan"))
const PersonalPH2 = React.lazy(() => import("./views/PersonalPH2"))
const CISBroadband = React.lazy(() => import("./views/util-page/CISBroadband"))
const PersonalPrepaid = React.lazy(() => import("./views/PersonalPrepaid"))

// Chinese New Year
const Promo = React.lazy(() => import("./views/cny/Promo"))
const Birthday = React.lazy(() => import("./views/cny/Birthday"))
const HuatAh = React.lazy(() => import("./views/cny/HuatAh"))
const FreeTShirt = React.lazy(() => import("./views/cny/FreeTShirt"))
const NDP2024 = React.lazy(() => import("./views/cny/Ndp2024"))
const bye3G = React.lazy(() => import("./views/cny/Bye3G"))
const incomeTravel = React.lazy(() => import("./views/cny/IncomeTravel"))
const promoSwitch = React.lazy(() => import("./views/cny/PromoSwitch"))
const ITShow = React.lazy(() => import("./views/cny/ITShow"))
const CEE = React.lazy(() => import("./views/cny/CEEITShow"))

// FBB
const BroadbandReg = React.lazy(() => import('./views/util-page/fbb/Broadband'))
const BroadbandMain = React.lazy(() => import('./views/util-page/fbb/BroadbandMain'))
const BroadbandWalkIn = React.lazy(() => import('./views/util-page/fbb/BroadbandWalkIn'))
const BroadbandHuaWei = React.lazy(() => import('./views/util-page/fbb/BroadbandHuaWei'))
const BroadbandLearnMore = React.lazy(() => import('./views/util-page/fbb/BroadbandLearnMore'))
const BroadbandDevice = React.lazy(() => import('./views/util-page/fbb/BroadbandDevices'))
const NASLanding = React.lazy(() => import('./views/util-page/fbb/NASLanding')) //NAS
const DonwloadAuthorisationLetter = React.lazy(() => import("./views/download-page/AuthorisationLetterDownload"))
const DonwloadAuthorisationCompanyLetter = React.lazy(() => import("./views/download-page/AuthorisationCompanyLetterDownload"))

// MSIG
const MsigLanding = React.lazy(() => import('./views/util-page/msig/MsigLanding'))
// Trust
const TrustLanding = React.lazy(() => import('./views/util-page/trust/TrustLanding'))
// Sharp
const SharpLanding = React.lazy(() => import('./views/util-page/sharp/SharpLanding'))



const routes = [
    { path: "/activate", name: "Activate", component: Activate, exact: true },
    { path: "/account", name: "Account", component: Account, exact: true },
    // { path: "/50gb-prepaid-plan", name: "SimPrepaid", component: SimPrepaid, exact: true },
    { path: "/seniors-signup-new", name: "Seniors Sign Up New", component: SeniorsSignUpNew, exact: true },
    { path: "/50gb-business-plan", name: "Business", component: Bo50GB, exact: true },
    { path: "/5G-bundle", name: "5G", component: FiveGBundle, exact: true },
    { path: "/press-release", name: "Press Release", component: PressRelease, exact: true },
    { path: "/careers", name: "Careers", component: Careers, exact: true },
    { path: "/careers-terms-and-conditions", name: "Careers Terms and Conditions", component: CareerTerms, exact: true },
    { path: "/cis", name: "CIS", component: Cis, exact: true },
    { path: "/guide", name: "User Guide", component: UserGuide, exact: true },
    { path: "/complaint-handling-policy", name: "Complaint Handling Policy", component: Complaint, exact: true },
    { path: "/IDD-Destinations", name: "CIS Destinations IDD", component: CisNEWIDD, exact: true },
    { path: "/roaming", name: "Roaming", component: Roaming, exact: true },
    { path: "/data-protection-notice", name: "Data Protection Notice", component: DataProtection, exact: true },
    { path: "/collect", name: "SIM Pick-up and Activation", component: Collect, exact: true },
    { path: "/walk-in", name: "Walk-in to Sign up, Renew and Recharge", component: Walkin, exact: true },
    { path: "/idd", name: "IDD Rates and International SMS", component: Idd, exact: true },
    { path: "/terms", name: "TPG Mobile Terms and Conditions", component: Terms, exact: true },
    { path: "/lucky-number", name: "Lucky Number", component: LuckyNumber, exact: true },
    { path: "/wireless-sg", name: "Wireless SG", component: WirelessSg, exact: true },
    { path: "/prohibited", name: "Prohibited", component: Prohibited, exact: true },
    { path: "/prohibited/mt1", name: "Prohibited MT-1", component: ProhibitedMt1, exact: true },
    { path: "/prohibited/mt2", name: "Prohibited MT-2", component: ProhibitedMt2, exact: true },
    { path: "/prohibited/mt3", name: "Prohibited MT-3", component: ProhibitedMt3, exact: true },
    { path: "/prohibited/mt4", name: "Prohibited MT-4", component: ProhibitedMt4, exact: true },
    { path: "/prohibited/mt5", name: "Prohibited MT-5", component: ProhibitedMt5, exact: true },
    { path: "/prohibited/mt6", name: "Prohibited MT-6", component: ProhibitedMt6, exact: true },
    { path: "/prohibited/mt7", name: "Prohibited MT-7", component: ProhibitedMt7, exact: true },
    { path: "/prohibited/mt8", name: "Prohibited MT-8", component: ProhibitedMt8, exact: true },
    { path: "/prohibited/mt9", name: "Prohibited MT-9", component: ProhibitedMt9, exact: true },
    { path: "/super-IDD", name: "SIMBA Super IDD Pack", component: SuperIddPack, exact: true },
    { path: "/forms", name: "Forms", component: Forms, exact: true },
    { path: "/esim", name: "ESIM", component: Esim, exact: true },
    { path: "/wifi", name: "Wifi", component: Wifi, exact: true },
    { path: "/ilovesimba", name: "I Love SIMBA", component: GiveawayCampaign, exact: true },
    { path: "/help", name: "Help Redirect", component: HelpRedirect, exact: true },
    { path: "/get-identity", name: "Get Identify", component: GetIdentify, exact: true },
    { path: "/5G-bundle-ZTE", name: "ZTE Bundle", component: ZteCampaign, exact: true },
    { path: "/rechargeandwin", name: "Recharge And Win", component: RechargeCampaign, exact: true },
    { path: "/getsimba5g", name: "Get Simba 5G", component: Getsimba5gCampaign, exact: true },
    { path: "/singpass-success", name: "Success", component: SingpassSuccess, exact: true },
    { path: "/singpass-error", name: "Success", component: SingpassError, exact: true },
    { path: "/ont-collect", name: "ONT Pick Up", component: ONTCollect, exact: true },

    // broadband
    { path: "/cis-broadband", name: "CISBroadband", component: CISBroadband, exact: true },
    { path: "/broadband/reg", name: "BroadbandReg", component: BroadbandReg, exact: true },
    { path: "/broadband", name: "BroadbandMain", component: BroadbandMain, exact: true },
    { path: "/broadband-setup", name: "Broadband Setup", component: BroadbandSetup, exact: true },
    { path: "/broadband/walk-in", name: "Broadband Walk-In", component: BroadbandWalkIn, exact: true },
    { path: "/broadband/huawei-emp", name: "Broadband Hua Wei", component: BroadbandHuaWei, exact: true },
    { path: "/broadband/10Gbps-broadband-what-you-need-to-know", name: "Broadband 10Gbps Learn More", component: BroadbandLearnMore, exact: true },
    { path: "/broadband/devices", name: "Broadband Devices", component: BroadbandDevice, exact: true },

    // New Design
    { path: "/home", name: "Home Phase 2", component: HomePH2, exact: true },
    { path: "/data-only", name: "New Data Only", component: NewDOPlan, exact: true },
    { path: "/business-plan", name: "BO15", component: Bo15, exact: true },
    { path: "/personal", name: "Personal", component: PersonalPH2, exact: true },
    { path: "/personal-prepaid", name: "Personal Prepaid", component: PersonalPrepaid, exact: true },


    // Chinese New Year
    { path: "/promo", name: "Promo", component: Promo, exact: true },
    { path: "/birthday", name: "Birthday", component: Birthday, exact: true },
    { path: "/huat-ah", name: "Huat Ah", component: HuatAh, exact: true },
    { path: "/free-t-shirt", name: "Free T Shirt", component: FreeTShirt, exact: true },
    { path: "/ndp2024", name: "SIMBA X NDP 2024", component: NDP2024, exact: true },
    { path: "/bye3G", name: "bye3G", component: bye3G, exact: true },
    { path: "/income-travel", name: "bye3G", component: incomeTravel, exact: true },
    { path: "/promo/switch", name: "switch", component: promoSwitch, exact: true },
    { path: "/promo/IT-show", name: "IT show", component: ITShow, exact: true },
    { path: "/promo/CEE", name: "IT show", component: CEE, exact: true },

    // Download File
    { path: "/download/authorisation-letter", name: "Download Authorisation-Letter", component: DonwloadAuthorisationLetter, exact: true },
    { path: "/download/authorisation-company-letter", name: "Download Authorisation-Company-Letter", component: DonwloadAuthorisationCompanyLetter, exact: true },
    
    // PROMOS

    { path: "/msig", name: "MSIG Landing", component: MsigLanding, exact: true },    // MSIG 
    { path: "/promo/trust", name: "Trust Landing", component: TrustLanding, exact: true },    // Trust 
    { path: "/promo/sharp", name: "Sharp Landing", component: SharpLanding, exact: true },    // Sharp
    { path: "/broadband/NAS", name: "NAS Landing", component: NASLanding, exact: true },    // NAS
]

export default routes